<template
  ><v-dialog v-model="dialog" persistent max-width="600px">
    <v-card class="pa-0" >
 <v-toolbar color="primary darken-1" dark dense>
        {{ this.isEdit ? $t("portfolio.comment.edit") : $t("portfolio.comment.add") }}
        <v-spacer></v-spacer>

        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      
      <v-card-text>
        <v-form ref="commentForm">
          <v-container>
            <v-row class="mt-4">
              <v-col cols="12">
                <v-textarea
                  no-resize
                  rows="7"
                  v-model="comment.commentText"
                  :label="$t('portfolio.comment.text')"
                  outlined
                  :rules="[
                    value => value.length >= 1 || $t('portfolio.comment.validation.minLength')
                  ]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions >
        <v-btn
          color="primary"
          :disabled="!comment.commentText || comment.commentText.length < 1"
          @click="submitComment"
        >
          {{ $t("save") }}
        </v-btn>
        <v-btn color="red" text @click="closeDialog">{{ $t("cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog></template
>

<script>
export default {
  data() {
    return {
      dialog: false,
      isEdit: false,
      comment: {
        sourceGuid: "",
        sourceType: null,
        commentText: ""
      }
    };
  },
  methods: {
    showDialog(sourceType, sourceGuid) {
      this.clearForm();
      this.comment.sourceType = sourceType;
      this.comment.sourceGuid = sourceGuid;
      this.isEdit = false;
      this.dialog = true;
    },
    showEditDialog(existingComment) {
      this.comment = { ...existingComment };
      this.isEdit = true;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    clearForm() {
      this.comment = {
        sourceGuid: "",
        sourceType: null,
        commentText: ""
      };
    },
    submitComment() {
      if (this.isEdit) {
        this.axios
          .post("Comment/Update", {
            commentGuid: this.comment.commentGuid,
            commentText: this.comment.commentText
          })
          .then(response => {
            this.$emit("edit", response.data.data);
          })
          .catch(error => {
            this.$emit("error", error.message);
          });
      } else {
        this.axios
          .post("Comment/Create", this.comment)
          .then(response => {
             this.$emit("add", response.data.data);
          })
          .catch(error => {
            this.$emit("error", error.message);
          });
      }
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.headline {
  font-weight: bold;
}

.v-card {
  padding: 16px;
}
</style>
